var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Breadcrumb'),_c('Messages'),_c('section',{staticClass:"py-3"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"flex flex-col-reverse justify-between -mx-2 lg:my-4 lg:flex-row"},[_c('SideNavigator',{attrs:{"links":_vm.links}}),_c('router-view')],1)])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }